// src/js/reducers/index.js
import { combineReducers } from 'redux';
//import { connectRouter } from 'connected-react-router'
import sitelogs from './siteLogReducer';
import sitelogSummary from './siteLogSummaryReducer';
import permissionTypes from './permissionReducer';
import personnel from './personnelReducer';
import projects from './projectReducer';
import menu from './menuReducer';
import loggedIn from './authReducer';
import fatigue from './fatigueReducer';
import picops from './picopReducer';
import es from './esReducer';
import registerLocations from './registerLocationReducer';
import register from './registerReducer';
import workTypes from './workTypeReducer';
import ajaxCallsInProgress from './ajaxStatusReducer';
import companies from './companyReducer';
import users from './userReducer';
import collars from './collarReducer';
import roles from './roleReducer';
//import {reducer as toastrReducer} from 'react-redux-toastr'
import fatigueDefaults from './fatigueDefaultReducer';
import userLocation from './userLocationReducer';
//import racecard from './raceCardReducer';
import distance from './distanceReducer';
import registerLogs from './registerLogReducer';
import timeLoss from './timeLossReducer';
import worksiteStats from './worksiteStatReducer';
import homeStats from './homeStatReducer';
import jobTypes from './jobTypeReducer';
import accidentTypes from './accidentTypeReducer';
import jobAttention from './jobAttentionReducer';
import jobWorkload from './jobWorkloadReducer';
import postcodes from './postcodeReducer';
import fileTypes from './fileTypeReducer';
import sectionTypes from './sectionTypeReducer';
import fieldSchema from './fieldSchemaReducer';
import clients from './clientReducer';

export const rootReducer = (history) => combineReducers({
  
  sitelogs: sitelogs,
  personnel: personnel,
  postcodes: postcodes,
  fileTypes: fileTypes,
  sectionTypes: sectionTypes,
  users: users,
  fieldSchema: fieldSchema,
  registerLogs: registerLogs,
  sitelogSummary: sitelogSummary,
  permissionTypes: permissionTypes,
  distance: distance,
  workTypes: workTypes,
  userLocation: userLocation,
  projects: projects,
  clients: clients,
  collars: collars,
  jobAttention: jobAttention,
  jobWorkload: jobWorkload,
  registerLocations: registerLocations,
  menu: menu,
  fatigueDefaults: fatigueDefaults,
  jobTypes: jobTypes,
  //toastr: toastrReducer,
  loggedIn: loggedIn,
  roles: roles,
  //racecard: racecard,
  accidentTypes: accidentTypes,
  fatigue: fatigue,
  worksiteStats: worksiteStats,
  homeStats: homeStats,
  companies: companies,
  picops: picops,
  timeLoss: timeLoss,
  es: es,
  register: register,
  ajaxCallsInProgress: ajaxCallsInProgress,
  //router: connectRouter(history)

});

// const initialState = {
//   sitelogs: {},
//   personnel: {},
//   postcodes: {},
//   fileTypes: {},
//   sectionTypes: {},
//   users: {},
//   registerLogs: {},
//   sitelogSummary: {},
//   permissionTypes: {},
//   distance: {},
//   workTypes: {},
//   userLocation: {},
//   projects: {},
//   jobAttention: {},
//   jobWorkload: {},
//   registerLocations: {},
//   menu: {},
//   fatigueDefaults: {},
//   jobTypes: {},
//   loggedIn: {},
//   roles: {},
//   racecard: {},
//   accidentTypes: {},
//   fatigue: {},
//   worksiteStats: {},
//   homeStats: {},
//   companies: {},
//   picops: {},
//   timeLoss: {},
//   es: {},
//   register: {},
//   ajaxCallsInProgress: {},
// }

// export const rootReducer = (history) => (state, action) => {
//   if(action.type === 'LOGOUT')
//     state = initialState

//   console.log(state, action, history)
//   return appReducer(state, action, history)
// }
